import { mergeMap, map, filter } from 'rxjs/operators';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Config } from '../config';
import * as loadjs from 'loadjs';
import { MessageService } from 'primeng/api';
import * as signalR from '@microsoft/signalr';
import { IntlService } from '@progress/kendo-angular-intl';

// eslint-disable-next-line @typescript-eslint/ban-types
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [MessageService],
})
export class AppComponent implements OnInit, AfterViewInit {
  firstLoad = true;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private messageService: MessageService,
    public intlService: IntlService
  ) {}

  ngOnInit(): void {
    this.setPageTitle();
  }

  ngAfterViewInit() {
    // Google Tag Manager
    const gtagToken = Config.gtagToken;
    loadjs(`https://www.googletagmanager.com/gtag/js?id=${gtagToken}`);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/login') {
          if (this.firstLoad) {
            gtag('js', new Date());
            gtag('config', gtagToken);
            this.firstLoad = false;
          }
        }
      }
    });

    // Initialise Signal R Notifications
    this.initialiseSignalR();
  }

  initialiseSignalR() {
    const apiEndpoint = Config.serverUrl;
    const srEndpoint = apiEndpoint + 'notify';
    // console.log('Connecting SignalR at ' + srEndpoint);
    // SignalR code... uncomment when implementing
    const connection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Warning)
      .withUrl(srEndpoint)
      .build();

    connection
      .start()
      .then(function () {
        // console.log('Connected SignalR at ' + srEndpoint);
      })
      .catch(function (err) {
        return console.error('Unable to connect to SignalR messaging Service. ' + err.toString());
      });

    connection.on('BroadcastMessage', (type: string, payload: string) => {
      this.messageService.add({
        severity: type,
        summary: payload,
        detail: 'System Administrator',
        closable: false,
        life: 30000,
        icon: '',
      });
    });
    connection.on(
      'BroadcastMessage2',
      (
        type: string,
        title: string,
        message: string,
        closable: boolean,
        timeout: number,
        sticky: boolean
      ) => {
        this.messageService.add({
          severity: type,
          summary: title,
          detail: message,
          closable: closable,
          life: timeout,
          icon: '',
          sticky: sticky,
        });
      }
    );
  }

  setPageTitle() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data)
      )
      .subscribe((event) => this.titleService.setTitle(event['title']));
  }
}
